import "jquery-drawer";

//DrawerJS
$(".drawer").drawer();
$(".drawer-nav").on("click", function () {
  $(".drawer").drawer("close");
});
